function DisplayTrack ( { currentTrack, trackIndex } ) {

    return(
        <>
            <div className="cover">
                {/* <img id="cover-img" src={`./music/${currentTrack.location}/${currentTrack.cover}`} alt="Album cover" /> */}
            </div>            
            <div className="info">
                <div className="song-display">
                    <h2>{currentTrack.song}</h2>
                </div>
                <div className="song-history">
                    <div>
                        <h3><small>Session: {currentTrack.session}</small></h3>
                    </div>
                    <div>
                        <h3><small>Distribution: {currentTrack.emailDate}</small></h3>
                    </div>
                    <div>
                        <h3><small>File: {currentTrack.filename}</small></h3>
                    </div>
                </div>
                <div className="song-details">
                    <div>
                        <h3><small>Track: {trackIndex + 1}</small></h3>
                    </div>
                    <div>
                        <h3><small>Key: {currentTrack.key}</small></h3>
                    </div>
                    <div>
                        <h3><small>Tempo: {currentTrack.tempo}</small></h3>
                    </div>
                </div>
                <div className="song-extras">
                    <div>
                        {(currentTrack.chart !== "") && <h3><small>Chart: {currentTrack.chart}</small></h3>}
                    </div>
                    <div>
                        {(currentTrack.lyrics !== "") && <h3><small>Lyrics: {currentTrack.lyrics}</small></h3>}
                    </div>
                    <div>
                        {(currentTrack.comment !== "") && <h3><small>Status: {currentTrack.comment}</small></h3>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default DisplayTrack